import type { WarrantyClaim } from '../types';

import { WarrantyClaimCard } from './warranty-claim-card';
import styles from './warranty-claims-grid.module.scss';

export type WarrantyClaimsGridProps = {
  claims: WarrantyClaim[];
  onOpen: (claim: WarrantyClaim) => void;
};

/** Responsive card grid for the Warranty Claims listing (Figma 2708-240334). */
export function WarrantyClaimsGrid({ claims, onOpen }: WarrantyClaimsGridProps) {
  return (
    <div className={styles.grid}>
      {claims.map((claim) => (
        <WarrantyClaimCard key={claim.id} claim={claim} onOpen={onOpen} />
      ))}
    </div>
  );
}
